import { CustomHtmlProps } from "./types";
import React from "react";
import classNames from "classnames";
import parse from "html-react-parser";

const CustomHtml = ({ html, customClass }: CustomHtmlProps) => {
  const classes = classNames("CustomHtml", customClass);

  return (
    <div className={`${classes}`}>{html.html ? parse(html.html) : ""}</div>
  );
};

export default CustomHtml;
